import * as Yup from "yup";
import { PHONE_NUMBER_REGEX } from "../constants";
export const newCompanyValidationSchema = Yup.object({
  name: Yup.string().required("Company Name Is Required"),
  business_name: Yup.string().required("Legal Business Name Is Required"),
  //   active: Yup.boolean().required("Required"),

  //   // validate
  //   expected_revenue: Yup.number("Must be a number").min(
  //     0,
  //     "Must be greate than or equal to 0"
  //   ),
  //   probability: Yup.number("Must be a number").positive(
  //     "Must be a positive number"
  //   ),
  //   partner_id: Yup.number(),
  //   email_from: Yup.string().email("Must be a valid email"),
  //   phone: Yup.string().matches(
  //     PHONE_NUMBER_REGEX,
  //     "Must be a valid phone number"
  //   ),
  //   date_deadline: Yup.date("Must be a valid date"),
  //   priority: Yup.number("Must be a number"),
  //   lang_id: Yup.string().required("Required"),
  //   city: Yup.string(),
  //   street: Yup.string(),
  //   zip: Yup.string(),
  //   partner_name: Yup.string(),
  //   tag_ids: Yup.array().of(Yup.number()), //  tag_ids: [[6, false, [1]]],
  //   description: Yup.string(),
});
